import type { JSX } from 'react';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { UniversalSelect } from '@feathr/components';

import * as styles from './SocialPreviewTypeSelector.css';

export type TSocialPreviewType =
  | 'facebook_newsfeed'
  | 'facebook_story'
  | 'instagram_feed'
  | 'instagram_story';

interface ISocialPreviewOption {
  id: TSocialPreviewType;
  name: string;
}

export interface ISocialPreviewTypeSelectorProps {
  value: TSocialPreviewType;
  onChange: (type: TSocialPreviewType) => void;
}

function SocialPreviewTypeSelector({
  value,
  onChange,
}: Readonly<ISocialPreviewTypeSelectorProps>): JSX.Element {
  const { t } = useTranslation();

  const options: ISocialPreviewOption[] = useMemo(
    () => [
      { id: 'facebook_newsfeed', name: t('Facebook newsfeed') },
      { id: 'facebook_story', name: t('Facebook story') },
      { id: 'instagram_feed', name: t('Instagram feed') },
      { id: 'instagram_story', name: t('Instagram story') },
    ],
    [t],
  );

  const selectedOption = options.find((option) => option.id === value);

  return (
    <UniversalSelect<ISocialPreviewOption>
      isClearable={false}
      isSearchable={false}
      name={'social-preview-type'}
      onSelectSingle={(option: ISocialPreviewOption) => {
        onChange(option.id);
      }}
      options={options}
      value={selectedOption}
      wrapperClassName={styles.root}
    />
  );
}

export default SocialPreviewTypeSelector;
